__turbopack_context__.v({
  "fadeIn": "footer-module__nP6W3G__fadeIn",
  "footer": "footer-module__nP6W3G__footer",
  "footerContent": "footer-module__nP6W3G__footerContent",
  "icon": "footer-module__nP6W3G__icon",
  "leftSection": "footer-module__nP6W3G__leftSection",
  "link": "footer-module__nP6W3G__link",
  "rightSection": "footer-module__nP6W3G__rightSection",
});
